.itemHeader {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5em;
  white-space: nowrap;
}
